'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCc = function FaCc(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15.2 22.2h4.1q-0.3 3-2 4.8t-4.1 1.8q-3.2 0-5-2.3t-1.8-6.1q0-3.8 1.8-6.1t4.6-2.3q2.8 0 4.5 1.7t1.9 4.8h-4q-0.1-1.2-0.7-1.9t-1.6-0.7q-1.1 0-1.7 1.2t-0.6 3.4q0 1 0.1 1.7t0.4 1.3 0.7 1 1.3 0.4q1.9 0 2.1-2.7z m13.9 0h4q-0.3 3-1.9 4.8t-4.2 1.8q-3.1 0-4.9-2.3t-1.8-6.1q0-3.8 1.8-6.1t4.5-2.3q2.9 0 4.5 1.7t1.9 4.8h-4q-0.1-1.2-0.7-1.9t-1.5-0.7q-1.1 0-1.8 1.2t-0.6 3.4q0 1 0.1 1.7t0.4 1.3 0.8 1 1.2 0.4q1 0 1.5-0.8t0.7-1.9z m6.9-2.3q0-4.1-0.3-6t-1.2-3.1q-0.1-0.2-0.2-0.3t-0.4-0.3-0.3-0.2q-1.7-1.2-13.6-1.2-12.1 0-13.7 1.2-0.1 0.1-0.4 0.2t-0.4 0.3-0.3 0.3q-0.9 1.1-1.1 3.1t-0.3 6q0 4 0.3 5.9t1.1 3.1q0.1 0.2 0.3 0.3t0.4 0.3 0.3 0.2q0.9 0.7 4.7 1t9.1 0.3q11.9 0 13.6-1.3 0.1 0 0.3-0.2t0.4-0.2 0.2-0.4q0.9-1.1 1.2-3t0.3-6z m3.8-14.8v29.8h-39.8v-29.8h39.8z' })
        )
    );
};

exports.default = FaCc;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/cc.js
// module id = 687
// module chunks = 35783957827783